// wc2-recovery-map.js — pure helpers for dropped-gen recovery (no DOM/browser
// deps so they're unit-testable). Shared by the inline onError recovery and the
// on-reload recovery in wcNN-upload.js.
//
// 2026-05-23 — Born from a real shipped bug: the recovery called the
// orchestrator's fetch-gen action with the field `generationId`, but the handler
// requires `generationIdPrefix` (verified live: wrong field -> HTTP 400; right
// field -> HTTP 200 with the completed art). And it mapped the response with the
// wrong field names. Both are encoded here, with tests in
// tests/unit/wc-recovery.test.mjs.

// fetch-gen requires `generationIdPrefix` (NOT `generationId`). The full
// generation id works fine as a prefix (text-contains + startsWith on the server).
export function buildFetchGenRequest(generationId, token) {
  return { token: token, action: 'fetch-gen', generationIdPrefix: String(generationId || '') };
}

// Map a fetch-gen response body into the orchResult shape showResult() expects.
//
// fetch-gen returns (verified live 2026-05-23):
//   { success, generationId, art:{url2K_Clean,url2K_Watermarked,url640_Clean},
//     canvas:{shopify}, canvasFramed:{shopify}, paintKit, straightOn:{url,ready} }
// showResult() reads:
//   orchResult.data[0].s3_url (hero art), orchResult.canvas.shopify,
//   orchResult.canvasFramed.shopify, orchResult.paintKit, orchResult.straightOn.url,
//   orchResult.mockups (optional — placeholders fill in when absent).
export function mapFetchGenToOrchResult(body, fallbackGenId) {
  body = body || {};
  const art = body.art || {};
  // Prefer the watermarked 2K for the pre-purchase reveal; fall back to clean,
  // then the small clean. (If the live reveal turns out to show the un-watermarked
  // art, swap the first two — single-line change.)
  const heroUrl = art.url2K_Watermarked || art.url2K_Clean || art.url640_Clean || null;
  return {
    phase: 'recovered',
    generationId: body.generationId || fallbackGenId || null,
    bubbleId: body.bubbleId || null,
    data: heroUrl ? [{ s3_url: heroUrl, display_url: heroUrl }] : [],
    canvas: body.canvas || null,
    canvasFramed: body.canvasFramed || null,
    paintKit: body.paintKit || null,
    straightOn: body.straightOn || null,
    // 2026-05-23 — Pass the mockup gallery imagery through (fetch-gen now returns
    // it) so the recovered reveal shows the art-on-canvas/framed gallery, not a
    // blank hero. showResult reads mockups.canvas / .framed / .paintKit / .pbn*.
    mockups: body.mockups || null,
  };
}
